import { render, staticRenderFns } from "./DetailsHead.vue?vue&type=template&id=32331674&scoped=true"
import script from "./DetailsHead.vue?vue&type=script&lang=js"
export * from "./DetailsHead.vue?vue&type=script&lang=js"
import style0 from "./DetailsHead.vue?vue&type=style&index=0&id=32331674&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32331674",
  null
  
)

export default component.exports